import i18n from '../../../../i18n';
import type { IL10nString, IL10nUrl } from '../../domain';

/**
 * this "service" is used to import i18next translations from objects, mainly for the keystore
 *
 * this turned out to be pretty opaque and difficult to read - do not use this for new code
 */
export class I18ImportService {
    static triggerUIUpdate() {
        const currentLanguage = i18n.language;
        i18n.changeLanguage(currentLanguage);
    }

    static isL10nString(object: any): object is IL10nString {
        return 'languageCode' in object && 'translation' in object;
    }

    static isUrlL10nString(object: any): object is IL10nUrl {
        return I18ImportService.isL10nString(object) && 'url' in object;
    }

    importTranslations(object: any) {
        const translations = this.resolveL10nResourcesFromObject(object);

        Object.keys(translations).forEach((lang) => i18n.addResources(lang as any, translations[lang]));

        I18ImportService.triggerUIUpdate();
    }

    resolveL10nResourcesFromObject(object: object, resourcePath = '', accumulator: any[] = []) {
        // eslint-disable-next-line no-restricted-syntax
        for (const objectKey in object) {
            // eslint-disable-next-line no-prototype-builtins
            if (!object.hasOwnProperty(objectKey) || !(object[objectKey] instanceof Object)) {
                continue;
            }
            const newResourcePath = resourcePath ? `${resourcePath}.${objectKey}` : objectKey;
            if (I18ImportService.isL10nString(object[objectKey])) {
                if (!accumulator[object[objectKey].languageCode]) {
                    accumulator[object[objectKey].languageCode] = {};
                }
                if (I18ImportService.isUrlL10nString(object[objectKey])) {
                    accumulator[object[objectKey].languageCode][`${resourcePath}.label`] = object[objectKey].translation;
                    accumulator[object[objectKey].languageCode][`${resourcePath}.url`] = object[objectKey].url;
                } else {
                    accumulator[object[objectKey].languageCode][resourcePath] = object[objectKey].translation;
                }
            }
            this.resolveL10nResourcesFromObject(object[objectKey], newResourcePath, accumulator);
        }

        return accumulator;
    }
}
